import { AutocompleteInput, BooleanField, ReferenceInput, useTranslate } from "react-admin";
import {
  Datagrid,
  DateField,
  EditButton,
  FunctionField,
  List,
  TextField,
  useRecordContext,
} from "react-admin";
import { getTokenData, isAdmin } from "../utils/token-data";

const TripEditButton = () => {
  const record = useRecordContext();
  if (!isAdmin() && record.approvalStatus !== "pending") return null;
  return <EditButton />;
};

const tripFilters = [
  <ReferenceInput label="User" source="user.id" reference="users" filter={{ role: 'user' }} >
    <AutocompleteInput label="User" optionText={value => `${value.firstName} ${value.lastName}`} />
  </ReferenceInput>
];

const TripList = () => {
  const translate = useTranslate();

  return (
    <List
      filterDefaultValues={
        isAdmin()
          ? {}
          : {
            "user.id": getTokenData().id,
          }
      }
      sort={{ field: 'date', order: 'DESC' }}
      filters={isAdmin() ? tripFilters : []}
    >
      <Datagrid>
        {isAdmin() && (
          <FunctionField
            label={translate("trip.name")}
            render={(record) =>
              `${record.user.firstName} ${record.user.lastName}`
            }
          />
        )}
        <DateField source="date" label={translate("date")} />
        <TextField source="distanceKm" label={translate("trip.distanceKm")} />
        <BooleanField source="asDriver" label={translate("trip.asDriver")} />
        <FunctionField
          label={translate("trip.approvalStatus")}
          render={record => translate(`approvalStatus.${record.approvalStatus}`)}
        />
        <TripEditButton />
      </Datagrid>
    </List>
  );
};

export default TripList;
